__turbopack_context__.v({
  "active": "LabeledSwitch-module__GR0pkq__active",
  "checked": "LabeledSwitch-module__GR0pkq__checked",
  "indicator": "LabeledSwitch-module__GR0pkq__indicator",
  "root": "LabeledSwitch-module__GR0pkq__root",
  "segment": "LabeledSwitch-module__GR0pkq__segment",
});
